module.exports = __webpack_public_path__ + "static/img/5636_phase_function_Paper_Points.e66f2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5636_phase_function_Paper_Points.png
// module id = 4i12
// module chunks = 0